import React from "react";
import "react-responsive-carousel/lib/styles/carousel.min.css";
import "src/dist/index.css";
import { Provider } from "react-redux";
import { store } from "common/store";
import { Tracking } from "common/components/Tracking";
import { useServiceWorker } from "common/hooks/useServiceWorker";
import { Toaster } from "react-hot-toast";
import { RemoteStorageProvider } from "common/components/RemoteStorage/RemoteStorageProvider";
import { Outlet } from "react-router";
import { HamburgerMenu } from "common/components/HamburgerMenu";
import { NavigatorListener } from "common/components/Navigator/Listener";
import { NavigatorContextProvider } from "common/components/Navigator/Context";
import { LiveChat } from "src/LiveChat";

export const Root: React.FC<{}> = () => {
  useServiceWorker();
  return (
    <Provider store={store}>
      <Tracking>
        <RemoteStorageProvider>
          <NavigatorContextProvider>
            <LiveChat />
            <Toaster position="top-right" />
            <Outlet />
            <HamburgerMenu />
            <NavigatorListener />
          </NavigatorContextProvider>
        </RemoteStorageProvider>
      </Tracking>
    </Provider>
  );
};
